import { render, staticRenderFns } from "./CaseScenario.vue?vue&type=template&id=876c867c&scoped=true&"
import script from "./CaseScenario.vue?vue&type=script&lang=js&"
export * from "./CaseScenario.vue?vue&type=script&lang=js&"
import style0 from "./CaseScenario.vue?vue&type=style&index=0&id=876c867c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876c867c",
  null
  
)

export default component.exports